import { Frame } from 'dragonmouse-shared/interfaces';

export type ExportScope = 'selected' | 'all';

export const scopeText = (selectedCount: number, allCount: number): string => {
	if (selectedCount === 0) return `Exporting all ${allCount} frames on canvas`;
	return `Exporting ${selectedCount} selected frames`;
};

export const resolveFrameIds = (
	fixedFrameIds: string[] | undefined,
	scope: ExportScope,
	selectedFrames: Frame[],
	allFrames: Frame[]
): string[] => {
	if (fixedFrameIds) return fixedFrameIds;
	if (scope === 'selected' && selectedFrames.length > 0) {
		return selectedFrames.map((f) => f.id);
	}
	return allFrames.map((f) => f.id);
};
